import { useSortable } from "@dnd-kit/sortable";
import { RowData, RowDataReducerAction } from "../../../../../types";
import { getInventoryBuildingIdentity } from "./utils/inventoryBuildingPriorityUtils";
import { CSS } from "@dnd-kit/utilities";
import { BuildingCard } from "./BuildingCard";
import styled from "styled-components";

interface SortableBuildingCardProps {
  building: RowData;
  index: number;
  onEdit: () => void;
  dispatch: React.Dispatch<RowDataReducerAction>;
  isReorderEnabled: boolean;
}

const DropPlaceholder = styled.div`
  border: 2px dashed #22c55e;
  border-radius: 8px;
  background-color: rgba(34, 197, 94, 0.04);
  min-height: 320px;
`;

export function SortableBuildingCard({
  building,
  index,
  onEdit,
  dispatch,
  isReorderEnabled,
}: Readonly<SortableBuildingCardProps>) {
  const sortableId = getInventoryBuildingIdentity(building, index);
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: sortableId,
    disabled: !isReorderEnabled,
  });

  const dragStyles: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    willChange: isDragging ? "transform" : "auto",
  };

  if (isDragging) {
    return (
      <div ref={setNodeRef} style={dragStyles}>
        <DropPlaceholder />
      </div>
    );
  }

  return (
    <div ref={setNodeRef} style={dragStyles}>
      <BuildingCard
        building={building}
        index={index}
        onEdit={onEdit}
        dispatch={dispatch}
        isDragging={false}
        dndAttributes={isReorderEnabled ? attributes : undefined}
        dndListeners={isReorderEnabled ? listeners : undefined}
      />
    </div>
  );
}
